/**
 * Tokens van de rustige projectpagina (ontwerp "projectpagina rustig", 23 okt 2026):
 * één accent (tertiary) plus neutrale tinten; rood alleen voor echte problemen.
 * Geen chips, pillen of randen — witruimte doet het werk.
 */
import { T } from '../../ProjectOverview/parts/stitch';

export const R = {
  accent: T.tertiary,          // #635983
  accentZacht: '#c9c3da',      // afgeronde fasen in de lijn
  tekst: T.text,
  tekst2: T.secondary,
  stil: T.outline,
  stiller: T.outlineVariant,
  lijn: T.surfaceHigh,
  scheiding: '#f0f2f3',
  vlak: '#ffffff',
  fout: T.error,
};

export const labelSx = {
  fontFamily: T.font, fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.12em',
  textTransform: 'uppercase', color: R.stil,
};

export const knopSx = {
  border: 0, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 1,
  bgcolor: R.accent, color: '#fff', borderRadius: '10px', px: 2.25, py: 1.25,
  fontFamily: T.font, fontWeight: 700, fontSize: '0.88rem', lineHeight: 1.2,
  '&:hover': { bgcolor: '#564d74' },
  '&:focus-visible': { outline: `2px solid ${R.accent}`, outlineOffset: 2 },
  '&:disabled': { opacity: 0.6, cursor: 'default' },
};

export const tekstLinkSx = {
  border: 0, bgcolor: 'transparent', p: 0, cursor: 'pointer', textAlign: 'left',
  fontFamily: T.fontBody, fontSize: '0.88rem', color: R.tekst2,
  '&:hover': { color: R.accent },
  '&:focus-visible': { outline: `2px solid ${R.accent}`, outlineOffset: 2, borderRadius: '4px' },
  '&:disabled': { opacity: 0.6, cursor: 'default' },
};
